'use client';

// Route-segment error boundary for the (authed) group. Paired with loading.tsx:
// a fetch that throws during an (authed) RSC render — or a transition that
// fails after the loading fallback — now surfaces here with a retry that calls
// reset(), so a dropped RSC fetch is recoverable in place instead of leaving the
// router parked on a spinner until a hard browser refresh.

import { useEffect } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ds';

export default function AuthedError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[(authed)/error]', error);
  }, [error]);

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--s-6)',
      }}
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1
          className="t-display"
          style={{ marginBottom: 'var(--s-2)', color: 'var(--text-primary)' }}
        >
          This page didn’t load
        </h1>
        <p
          className="t-body"
          style={{ color: 'var(--text-secondary)', marginBottom: 'var(--s-2)' }}
        >
          Something interrupted the request. You can retry without refreshing the
          page.
        </p>
        {error.digest && (
          <p
            className="t-mono"
            style={{ color: 'var(--text-tertiary)', marginBottom: 'var(--s-6)' }}
          >
            Error ID: {error.digest}
          </p>
        )}

        <div
          style={{
            display: 'flex',
            gap: 'var(--s-2)',
            justifyContent: 'center',
            flexWrap: 'wrap',
            marginTop: 'var(--s-4)',
          }}
        >
          <Button variant="primary" leftIcon="RotateCw" onClick={() => reset()}>
            Try again
          </Button>
          <Link
            href="/home"
            className="inline-flex items-center h-8 px-3.5 text-sm font-medium rounded-sm bg-surface-3 text-text-primary border border-border-default hover:bg-surface-2 transition-colors"
            style={{ textDecoration: 'none' }}
          >
            Go to home
          </Link>
        </div>
      </div>
    </div>
  );
}
